import React, {useState,useRef,useEffect} from 'react';
import {Form, Input, Button, Checkbox, Modal, AutoComplete, message} from 'antd';
import {UserOutlined, LockOutlined, CopyrightOutlined} from '@ant-design/icons';
import {http, history} from 'libs';
import {DebounceSelect} from 'components';
import styles from './login.module.less';

// the hook
import {useTranslation} from 'react-i18next';

const {Option} = AutoComplete;
const {Password} = Input

export default function Register() {
  const {t, i18n} = useTranslation();
  const [loading, setLoading] = useState(false);
  const [org, setOrg] = useState('')
  const [orgList, setOrgList] = useState([])

  const [countdown, setCountdown] = useState(0);      // 倒计时秒数，0 表示未开始
  const [sending, setSending] = useState(false); // 是否正在发送验证码
  const timerRef = useRef(null);                      // 存储定时器 ID
  const [form] = Form.useForm();

  // 倒计时逻辑
  const startCountdown = (seconds = 60) => {
    if (timerRef.current) return;                     // 防止重复开始
    setCountdown(seconds);
    timerRef.current = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          // 倒计时结束，清除定时器
          clearInterval(timerRef.current);
          timerRef.current = null;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // 组件卸载时清除定时器
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  const handleClick = async () => {
    try {
      await form.validateFields(['phone']); // 校验手机号字段
      // 如果校验通过，则可以获取验证码
    if (countdown > 0 || sending) return; // 倒计时中，不处理
    // 这里可以调用发送验证码的 API
    setSending(true);
    http.post('/javaApi/user/sendSmsCode', {
      phone: form.getFieldValue('phone'),
      type:1,
    })
      .then((res) => {
        console.log(res);
      })
    startCountdown(60);
    } catch (error) {
    } finally {
      setSending(false);
    }
  };

  function handleSubmit(formData) {
    setLoading(true);
    http.post('/javaApi/user/register', formData)
      .then(() => {
        setLoading(false);
        Modal.success({
          title: '注册提交成功',
          content: (
            <div>
              <p>工作人员将尽快审核，预计1-2个工作日内完成，审核通过后会通过短信通知您。</p>
            </div>
          ),
          okText: '返回首页',
          onOk() {
            history.push('/home')
          },
        });
      })
      .catch((err) => {
      })
      .finally(() => setLoading(false))
  }

  function getQccSearchList(val) {
    if(!val) {
      return Promise.resolve([])
    }else{
    return http.get('/javaApi/user/qccSearchList?keyword=' + val)
      .then((res) => {
        if(res.data.result && res.data.result.length > 0){
          return res.data.result.map(item => ({
            label: item.Name,
            value: item.Name,
          }))
        }else{
          return []
        }
      })
      .finally(() => setLoading(false))
    }
  }

  return (
    <div className={[styles.container, styles.register].join(" ")}>
      <div className={styles.formContainer}>
        <div className={styles.h1}>{t('欢迎加入Lab Direct平台')}</div>
        <div className={styles.formTip}>
          {t('如果您已有平台账号')} <a onClick={() => {
          history.push('/login')
        }}>{t('立即登录')}!</a>
        </div>
        <Form form={form} onFinish={handleSubmit} validateTrigger='onBlur'>

          <Form.Item
            label={t('电子邮箱')}
            name="email"
            rules={[
              {required: true, message: t('请输入电子邮箱') + '!'},
              {type: 'email', message: t('邮箱格式不正确') + '!'}
            ]}
            className={styles.formItem}>
            <Input autoComplete="new-password" placeholder={t('电子邮箱即为登录名')}/>
          </Form.Item>
          <Form.Item
            label={t('手机号码')}
            name="phone"
            rules={[
              {required: true, message: t('请输入手机号') + '!'},
              {pattern: /^[1]([3-9])[0-9]{9}$/, message: t('请输入正确的手机号码')}
            ]}
            className={styles.formItem}>
            <Input autoComplete="off" placeholder={t('请输入手机号')}/>
          </Form.Item>
          <Form.Item
            label={t('验证码')}
            name=""
            className={styles.formItem}>
             <Form.Item name="smsCode" noStyle  rules={[
                {required: true, message: t('请输入短信验证码') + '!'},
                {pattern: /^[0-9]{4}$/, message: t('验证码为4位数字') + '!'}]}>
                <Input className={styles.codeInput} autoComplete="off" placeholder={t('请输入短信验证码')}/>
              </Form.Item>
            <Button className={styles.getCodeBtn} onClick={handleClick} disabled={countdown > 0||sending} type="primary">{countdown > 0 ? countdown + '秒后重试' : t('获取验证码')}</Button>
          </Form.Item>
          <Form.Item
            label={t('设置密码')}
            name="password"
            rules={[
              {required: true, message: t('请设置登录密码') + '!'},
              {pattern: /^(?:(?=.*\d)(?=.*[a-zA-Z])|(?=.*\d)(?=.*[^a-zA-Z0-9])|(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])).{8,20}$/, message: t('密码8‑20位，需包含数字、字母、特殊字符至少两种') + '!'}
            ]}
            className={styles.formItem}>
            <Password autoComplete="new-password" className='rest-password' placeholder={t('密码8‑20位，需包含数字、字母、特殊字符至少两种') + '!'}/>
          </Form.Item>

          <Form.Item
            label={t('确认密码')}
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              {required: true, message: t('请再次输入密码') + '!'},
              ({getFieldValue}) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(t('两次输入密码不一致') + '!');
                },
              }),
            ]}
            className={styles.formItem}>
            <Password autoComplete="new-password" className='rest-password' placeholder={t('请再次输入密码')}/>
          </Form.Item>
         <Form.Item
            label={t('姓名')}
            name="name"
            rules={[
              {required: true, message: t('请输入您的姓名') + '!'},
              {pattern: /^[a-zA-Z\u4e00-\u9fa5]{2,20}$/, message: t('姓名限制2-20位，只能包含字母、中文') + '!'}
            ]}
            className={styles.formItem}>
            <Input autoComplete="off" placeholder={t('请输入您的姓名')}/>
          </Form.Item>

          <Form.Item
            label={t('公司名称')}
            name="companyName"
            required={true}
             rules={[{required: true, message: t('请输入公司全称') + '!'}]}
            className={styles.formItem}>
            <DebounceSelect
                showSearch
                placeholder={t('请输入公司名称')}
                fetchOptions={getQccSearchList}
                style={{
                  width: '100%',
                }}
              />
            {/* <Button className={`${styles.queryBtnBtn} ${styles.getCodeBtn}`} type="primary">{t('查询')}</Button> */}
          </Form.Item>


          <Form.Item>
            <Button size="large" type="primary" htmlType="submit" loading={loading}>{t('同意协议并注册')}</Button>
            <div className={styles.formTip}>
              <a className="theme_color" target='_blank'
                 href="/fqa?type=zcxy">{'《' + t('会员注册协议') + '》'}</a>
              {t('和')}
              <a className="theme_color" target='_blank'
                 href="/fqa?type=ysbhzc">{'《' + t('隐私保护政策') + '》'}</a>
            </div>
          </Form.Item>

        </Form>
      </div>

    </div>
  )
}
